
import React from 'react';
import {NavLink} from 'react-router-dom';
import './homePageComponent.css';

export const HomePageComponent = () => {
    return <main>
        <section className="main-content">
            <div className="hero-text">
                <div>Life Saving Drugs Distributors</div>
            </div>
            <div className="services-overlay">
                <div className="service-card">
                    <i className="fas fa-pills"></i>
                    <h3>Prescription Medicines</h3>
                    <p>Wide range of prescription medications available</p>
                </div>
                <div className="service-card">
                    <i className="fas fa-kit-medical"></i>
                    <h3>Surgical Products</h3>
                    <p>Essential surgical supplies and equipment</p>
                </div>
                <div className="service-card">
                    <i className="fas fa-notes-medical"></i>
                    <h3>Healthcare Products</h3>
                    <p>Quality healthcare and wellness products</p>
                </div>
                <div className="service-card">
                    <i className="fas fa-truck"></i>
                    <h3>Home Delivery</h3>
                    <p>Convenient doorstep delivery service</p>
                </div>
            </div>
            <div className="explore-medicines-container">
                <NavLink className="explore-medicines-link" to="/medicines">Explore Available Medicines</NavLink>
            </div>
        </section>
    </main>;
};